import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';

export default class TrainerPage extends React.Component {
	render() {
		return (
			<DocumentTitle title="Školitelé">
				<TabbablePage
					module="trainer"
					List={List}
					Form={Form}
					newTitle="Nový"
					listTitle="Seznam školitelů"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Trainer/Page.js